import { STORAGE_ID } from '@unistocks/shared/consts';
import { createMMKV } from 'react-native-mmkv';

export const storage = createMMKV({
  id: STORAGE_ID
});
